import React, { Suspense, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Bounds, OrbitControls, useGLTF } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import LoadingOverlay from '../../../common/loading-overlay';

import styles from './index.module.scss';

// eslint-disable-next-line react/prop-types -- fix this
const Model = ({ img }) => {
	const { scene } = useGLTF(img);
	return (
		<primitive
			scale={[1, 1, 1]}
			object={scene}
		/>
	);
};

const Render3DImage = ({ data }) => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(false);
	}, []);

	if (!data) return null;

	return (
		<div className={styles.render3dImage}>
			{loading && <LoadingOverlay fixed={false} />}

			<Canvas
				frameloop='demand'
				camera={{ position: [0, 0, 80], fov: 50 }}
				dpr={[1, 2]}
			>
				<ambientLight intensity={0.35} />
				<pointLight
					position={[10, 10, 10]}
					intensity={0.75}
				/>
				<Suspense fallback={null}>
					<Bounds
						fit
						clip
						margin={1.2}
					>
						<Model img={data} />
					</Bounds>
				</Suspense>
				<OrbitControls makeDefault />
			</Canvas>
		</div>
	);
};

Render3DImage.propTypes = {
	data: PropTypes.string,
};

export default Render3DImage;
